import React from 'react';
import Component from '@vfuk/core-grouped-text-input-with-label';
const GroupedTextInputWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default GroupedTextInputWithLabel;
